import { Location } from '@angular/common';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { WalletService } from '../../services/wallet.service';

import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';
import { BorderColorsEnum, NgxDividerComponent } from '@digipay/ngx-divider';
import { NgxCalloutComponent } from '@digipay/ngx-callout';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { MessageService } from '@client-monorepo/common/utilities';
import { IWalletProcess } from '../../models/wallet-cashin-model.interface';
import { WALLET_DEPOSIT_PROCESS_API, WALLET_WITHDROW_PROCESS_API } from '../../../../data-access/constants/api';
import { ConvertBankName } from '../../../../data-access/constants/banks-code-name';

@Component({
  selector: 'wealth-applet-wallet-transaction-info',
  standalone: true,
  imports: [PipesModule, NgxButtonComponent, NgxDividerComponent, NgxCalloutComponent],
  templateUrl: './wallet-transaction-info.component.html',
  styleUrl: './wallet-transaction-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalletTransactionInfoComponent implements OnInit {
  location = inject(Location);
  btnLoading = signal<boolean>(false);
  bottomSheet = inject<NgxBottomSheetService<WalletTransactionInfoComponent>>(NgxBottomSheetService);
  protected readonly BorderColorsEnum = BorderColorsEnum;
  navigationService = inject(WealthNavigationService);
  walletService = inject(WalletService);
  messageService = inject(MessageService);
  bankName = signal<string | undefined>(undefined);

  ngOnInit() {
    if (this.bottomSheet.data().data.iban) {
      this.bankName.set(ConvertBankName(this.bottomSheet.data().data.iban));
    }
  }

  continue() {
    this.btnLoading.set(true);
    const processData: IWalletProcess = {
      action: 'confirmed',
      walletName: this.bottomSheet.data().data.walletName,
      amount: this.bottomSheet.data().data.amount,
    };
    const apiUrl = this.bottomSheet.data().data.type === 'cashOut' ? WALLET_WITHDROW_PROCESS_API : WALLET_DEPOSIT_PROCESS_API;

    this.walletService.walletProcess(apiUrl, processData).subscribe((res) => {
      if (res.success && res && res.result && res.result.action === 'error') {
        this.messageService.showErrorMessage(res.result.data.message);
      }
      this.btnLoading.set(false);
    });
  }

  editPrice() {
    this.bottomSheet.closeBottomSheet();
  }
}
